export const getSpecialScheduleDate = (specialSchedule, isStart) => {
	const activeItem = specialSchedule?.find((item) => item.status === true);
	if (!activeItem) return undefined;
	return isStart ? activeItem.start : activeItem.end;
};
